import { selectAppConfig } from "./selectAppConfig";

export const selectApplicationInfo = state => selectAppConfig(state).application_info || {};
